import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-anchor-left-down-icon',
  templateUrl: './design-anchor-left-down.component.html'
})
export class DesignAnchorLeftDownComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
